const Footer = () => {
  return (
    <footer className="w-full px-[30px] py-7 mt-16 flex flex-col-reverse gap-3 sm:flex-row justify-between items-center text-white/30 text-[.85rem]">
      <p>© 2023 ScoreBox</p>
      <ul className="flex gap-6 items-center">
        {/* <li>About</li>
        <li>Support</li> */}
        {/* <li>Contact Us</li> */}
      </ul>
    </footer>
  );
};

export default Footer;
